/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rust_Fond_Ox_GnawInputs */

const en_rust_fond_ox_gnaw = /** @type {(inputs: Rust_Fond_Ox_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add User`)
};

const de_rust_fond_ox_gnaw = /** @type {(inputs: Rust_Fond_Ox_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add User" |
*
* @param {Rust_Fond_Ox_GnawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rust_fond_ox_gnaw = /** @type {((inputs?: Rust_Fond_Ox_GnawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rust_Fond_Ox_GnawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rust_fond_ox_gnaw(inputs)
	return de_rust_fond_ox_gnaw(inputs)
});